// Copy text to the clipboard. Resolves true on success, false on failure, so
// callers can show their own feedback (toast, inline "Copied!", etc.).
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
